
export interface MapOptions {
    disable?: boolean
    currentPosition?: boolean
    callbackCreate?: Function;
}

